import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { Tooltip } from '../../primitives/tooltip/tooltip';
import { Icon } from '../../primitives/icon/icon';
import { Toggle } from '../../primitives/toggle/toggle';
import { alertIndication } from '../../icons/processed';
import { useOnScroll } from '../../common/hooks';
export var MenuItemContext = React.createContext({ allowPropagation: false });
export var floaterMenuKey = 'floater-menu';
export var FloaterMenu = function (props) {
    var _a = useOnScroll(), scrolled = _a[0], onScroll = _a[1];
    var hasHeaderShadow = props.headerShadow || props.headerShadow === undefined;
    var classNames = namespacedClassnames(floaterMenuKey, props.className, { scrolled: scrolled, 'with-header': hasHeaderShadow });
    return React.createElement("div", { onScroll: onScroll, className: classNames }, props.children);
};
var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (e) {
            var _a = _this, props = _a.props, context = _a.context;
            if (!context.allowPropagation) {
                e.stopPropagation();
            }
            if (!props.disabled && props.onSelect) {
                props.onSelect(e);
            }
        };
        return _this;
    }
    MenuItem.prototype.render = function () {
        var props = this.props;
        var className = namespacedClassnames('menu-item', {
            disabled: props.disabled,
            icon: props.icon,
            selectable: !!props.onSelect
        }, props.type, props.className);
        var menuItem = (React.createElement("div", { className: className, "data-value": props.value, onClick: this.onClick },
            props.icon && React.createElement(Icon, { icon: props.icon }),
            props.children));
        var disabledText = typeof props.disabled !== 'boolean' ? props.disabled : '';
        return disabledText ? (React.createElement(Tooltip, { className: 'menu-item-disabled', body: disabledText, direction: 'left', relativeToBody: true }, menuItem)) : menuItem;
    };
    MenuItem.contextType = MenuItemContext;
    return MenuItem;
}(React.PureComponent));
export { MenuItem };
export var MenuItemDivider = function (props) {
    var className = namespacedClassnames('menu-item-divider', props.className || '');
    return React.createElement("div", { className: className });
};
export var MenuItemHeading = function (props) {
    var className = namespacedClassnames('menu-item-heading', props.className || '');
    return React.createElement("div", { className: className }, props.children);
};
export var MenuItemSubheading = function (props) {
    var className = namespacedClassnames('menu-item-subheading', props.className || '');
    return React.createElement("div", { className: className }, props.children);
};
export var MenuItemSectionHeading = function (props) {
    var toggle = props.toggle, alert = props.alert;
    var className = namespacedClassnames('menu-item-section-heading', props.className || '');
    return React.createElement("div", { className: className },
        alert ? React.createElement("div", { className: 'alert-warpper' },
            props.children,
            React.createElement(Tooltip, { body: alert, className: 'alert' },
                React.createElement(Icon, { icon: alertIndication }))) : props.children,
        toggle ? React.createElement(Toggle, __assign({}, toggle)) : null);
};
export var MenuItemGroupTitle = function (props) {
    var className = namespacedClassnames('menu-item-group-title', props.className || '');
    return React.createElement("div", { className: className }, props.children);
};
export var MenuItemSubtitle = function (props) {
    var className = namespacedClassnames('menu-item-subtitle', props.className || '');
    return React.createElement("div", { className: className },
        React.createElement("span", null, props.children));
};
//# sourceMappingURL=floater-menu.js.map